import { devtools } from 'zustand/middleware';
import { create } from 'zustand';

import { isProductionClient } from '../consts/environment';

const SCROLL_THRESHOLD = 50;

export interface ScrollPositionStoreState {
  scrollPosition: number;
  lastScrollY: number;
  isHeaderVisible: boolean;
  setScrollPosition: (offset: number) => void;
  updateScrollPosition: (scrollY: number) => void;
  initializeFromScrollPosition: (scrollY: number) => void;
}

export const useScrollPositionStore = create<ScrollPositionStoreState>()(
  devtools(
    (set, get) => ({
      scrollPosition: 0,
      lastScrollY: 0,
      isHeaderVisible: true,
      setScrollPosition: (offset) => set({ scrollPosition: offset }, undefined, 'setScrollPosition'),
      updateScrollPosition: (currentScrollY) => {
        const { lastScrollY } = get();
        const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';

        let isHeaderVisible: boolean;

        if (currentScrollY <= SCROLL_THRESHOLD) {
          isHeaderVisible = true;
        } else if (scrollDirection === 'up') {
          isHeaderVisible = true;
        } else {
          isHeaderVisible = false;
        }

        set({ isHeaderVisible, lastScrollY: currentScrollY }, undefined, 'updateScrollPosition');
      },
      initializeFromScrollPosition: (scrollY) => {
        set(
          {
            lastScrollY: scrollY,
            isHeaderVisible: scrollY <= SCROLL_THRESHOLD,
          },
          undefined,
          'initializeFromScrollPosition',
        );
      },
    }),
    {
      name: 'search-modules',
      store: 'scroll-position-store',
      enabled: !isProductionClient,
    },
  ),
);
